<template>
  <yi-pick-list @handleSelectPick="handleSelectPick"></yi-pick-list>
</template>

<script>
export default {
  name: 'pickList',
  methods: {
    handleSelectPick(pick) {
      let pages = getCurrentPages();
      let prevPage = pages[pages.length - 2];
      // console.log('%c [prevPage]: ', 'color:#1989fa;', prevPage.$vm);

      prevPage.$vm.selectPid = pick.pid;
      prevPage.$vm.selectPick = pick;
      uni.navigateBack({ delta: 1 });
    },
  },
};
</script>

<style scoped></style>
